import { withStyles } from '@material-ui/core';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';

import { expansionPanelDetailsStyles } from './expansion-panel-details.styles';

export const ExpansionPanelDetails = withStyles(expansionPanelDetailsStyles)(
  MuiAccordionDetails
);
